import { message } from 'antd';
import { useTranslation } from 'react-i18next';

function errorHandler(error: any): { messageKey: string; statusCode?: number } {
    let messageKey = 'errors.general';
    let statusCode: number | undefined;

    if (
        (error?.data && error?.data?.message) ||
        (error?.response && error?.response?.status)
    ) {
        const response = error?.data || error?.response?.data;
        statusCode = error?.status || error?.response?.status;

        switch (statusCode) {
            case 404:
                messageKey = 'errors.resourceNotFound';
                break;
            case 422:
                messageKey = response?.message;
                break;
            case 500:
                messageKey = 'errors.internalServerError';
                break;
            default:
                messageKey = response?.message || 'errors.general';
                break;
        }
    } else if (error?.message) {
        messageKey = error.message;
    }

    return { messageKey, statusCode };
}

export function useCheckResponse() {
    const { t } = useTranslation();

    const checkResponse = (
        res: any,
        type?:
            | 'create'
            | 'update'
            | 'send'
            | 'buy'
            | 'upload'
            | 'submit'
            | 'signout'
            | 'verify'
            | 'delete',
        name?: string
    ) => {
        const isSuccess =
            res?.data && !res.data.statusCode && typeof res.data !== 'string';

        if (isSuccess || res?.status === true) {
            if (type && name) {
                message.success({
                    content: t(`notification.success.${type}`, { name }),
                    className: 'response-success',
                    type: 'success',
                });
            }
            return { success: true, data: res.data };
        }

        const { messageKey, statusCode: errorCode } = errorHandler(
            res?.error || res
        );

        //401 Unauthorized
        if (errorCode !== 401) {
            message.error({
                content: t(messageKey),
                className: 'response-error',
                type: 'error',
            });
        }

        return { success: false, data: '' };
    };
    return {
        checkResponse,
        t,
    };
}
